<!-- 平台查看多控销售统计 - 销售统计头部 -->
<template>
    <div class="inline-view">
        <div class="eachRow" v-for="(item, index) in list" :key="index">
            <div>
              <span class="title">{{item.name}}</span>
              <el-tooltip :content="item.notice" placement="top" v-if="item.notice" >
                  <i class="el-icon-warning-outline" ></i>
              </el-tooltip>
            </div>
            <span class="value">{{item.value}}</span>
            <div class="line" v-if="index < list.length - 1"></div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PlSalesStatisticGrid',
    props:{
        list: {
          type: Array,
          default: () => []
        }
    },
    data() {
      return {
        
      }
    },
    methods: {
      
    }
  }
  </script>
  
  
  <style scoped lang="scss">
  .inline-view {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #fff;
    border-radius: 10px;
    .eachRow {
        // background-color: #f5f5f5;
        // border-radius: 10px;
        padding: 12px 24px;
        display: flex;
        justify-content: center;
        // margin-right: 24px;
        flex-direction: column;
        position: relative;
        .settled-order-tooltip {
            position: absolute;
            top:10px;
            right: 5px;
        }
        .title {
            font-size: 12px;
            color: #595959;
        }

       .value {
            font-size: 30px;
            color: #262626;
            font-weight: bold;
            margin-top: 10px;
        }
        .line {
            width: 1px;
            height: 20px;
            background-color: #e5e5e5;
            position: absolute;
            top: calc(50% - 10px);
            right: 0;
        }
    }
  }
  </style>